var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShieldCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2504 14.9994L13.7501 17.4995L18.7496 12.4993M24.999 16.25C24.999 22.5002 20.6244 25.6253 15.425 27.4379C15.1527 27.5301 14.8569 27.5257 14.5875 27.4254C9.37556 25.6253 5.001 22.5002 5.001 16.25V7.49972C5.001 7.16819 5.13268 6.85024 5.36708 6.61581C5.60148 6.38138 5.91939 6.24968 6.25088 6.24968C8.75063 6.24968 11.8753 4.74963 14.0501 2.84957C14.3149 2.62331 14.6517 2.499 15 2.499C15.3483 2.499 15.6851 2.62331 15.9499 2.84957C18.1372 4.76214 21.2494 6.24968 23.7491 6.24968C24.0806 6.24968 24.3985 6.38138 24.6329 6.61581C24.8673 6.85024 24.999 7.16819 24.999 7.49972V16.25Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShieldCheck);
export default __webpack_public_path__ + "static/media/icon_shield_check.397527365e2df040ace5b19afbb7f0eb.svg";
export { ForwardRef as ReactComponent };